(function ($) {
  'use strict';

  var WISHLIST_STORAGE_KEY = 'wishlist';
  var WISHLIST_COOKIE = 'wishlist';
  var STORAGE_DAYS = 30;
  var HEART_OUTLINE_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.7 10.9 19.7C6.1 15.4 3.2 12.7 3.2 9.2 3.2 6.3 5.4 4 8.3 4c1.6 0 3 .8 3.7 2 1-1.2 2.4-2 4-2 2.9 0 5.1 2.3 5.1 5.2 0 3.5-2.9 6.2-7.7 10.5L12 20.7Z"></path></svg>';
  var HEART_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="m12 21.3-1.4-1.2C5.4 15.4 2 12.4 2 8.8 2 5.8 4.4 3.5 7.4 3.5c1.7 0 3.4.8 4.6 2.1 1.2-1.3 2.9-2.1 4.6-2.1 3 0 5.4 2.3 5.4 5.3 0 3.6-3.4 6.6-8.6 11.3L12 21.3Z"></path></svg>';
  var EMPTY_STATE_HTML =
    '<div class="wishlist-empty-state"><p>Your wishlist is empty.</p></div>';

  function storageAvailable() {
    try {
      var testKey = '__wishlist_test__';
      window.localStorage.setItem(testKey, testKey);
      window.localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie =
      name + '=' + encodeURIComponent(value || '') + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
    }
    return '';
  }

  function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  function normalizeHandles(handles) {
    var seen = {};

    return $.grep(handles || [], function (item) {
      var handle = $.trim(String(item || ''));

      if (!handle || seen[handle]) return false;

      seen[handle] = true;
      return true;
    });
  }

  function getWishlistHandles() {
    var handles = [];

    if (storageAvailable()) {
      try {
        handles = JSON.parse(window.localStorage.getItem(WISHLIST_STORAGE_KEY) || '[]');
      } catch (error) {
        handles = [];
      }
    }

    if (!handles.length) {
      handles = getCookie(WISHLIST_COOKIE).split('__');
    }

    handles = normalizeHandles(handles);

    if (handles.length) {
      saveWishlistHandles(handles);
    }

    return handles;
  }

  function saveWishlistHandles(handles) {
    var normalized = normalizeHandles(handles);

    if (storageAvailable()) {
      if (normalized.length) {
        window.localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(normalized));
      } else {
        window.localStorage.removeItem(WISHLIST_STORAGE_KEY);
      }
    }

    if (normalized.length) {
      setCookie(WISHLIST_COOKIE, normalized.join('__'), STORAGE_DAYS);
    } else {
      eraseCookie(WISHLIST_COOKIE);
    }
  }

  function updateWishlistCount() {
    var count = getWishlistHandles().length;

    $('.pro-wishlist-section .wishlist-head h2 > span > span, .pro-wishlist-section .wishlist-head h3 span').text(count);
  }

  function setCardWishlistUI($scope, active) {
    var $proWishlist = $scope.find('.pro-wishlist');
    var $input = $proWishlist.find('input');
    var $label = $proWishlist.find('label .wishlist-label');

    if (!$proWishlist.length || !$label.length) return;

    if (active) {
      $input.addClass('wishlist_active').prop('checked', true);
      $proWishlist.addClass('active');
      $label.html(HEART_ICON);
    } else {
      $input.removeClass('wishlist_active').prop('checked', false);
      $proWishlist.removeClass('active');
      $label.html(HEART_OUTLINE_ICON);
    }
  }

  function setProductWishlistUI(active) {
    var $scope = $('.product-first-section .kga-pdp__wishlist');
    var $input = $scope.find('input');
    var $label = $scope.find('label .wishlist-label');
    var compact = $scope.hasClass('kga-pdp__wishlist');

    if (!$scope.length || !$label.length) return;

    if (active) {
      $input.addClass('wishlist_active').prop('checked', true);
      $scope.addClass('active');
      $label.html(compact ? HEART_ICON : 'Added to wishlist ' + HEART_ICON);
      $scope.find('label').attr({ 'aria-label': 'Added to wishlist', title: 'Added to wishlist' });
    } else {
      $input.removeClass('wishlist_active').prop('checked', false);
      $scope.removeClass('active');
      $label.html(compact ? HEART_OUTLINE_ICON : 'Add to wishlist ' + HEART_OUTLINE_ICON);
      $scope.find('label').attr({ 'aria-label': 'Add to wishlist', title: 'Add to wishlist' });
    }
  }

  function syncWishlistUI() {
    var handles = getWishlistHandles();

    updateWishlistCount();

    $('div.wish-lbl-wrp').each(function () {
      var $wrap = $(this);
      var handle = $wrap.find('.pro-wishlist input').attr('pro-handle');

      if (!handle) return;

      setCardWishlistUI($wrap, $.inArray(handle, handles) !== -1);
    });

    $('.product-first-section .kga-pdp__wishlist input[pro-handle]').each(function () {
      setProductWishlistUI($.inArray($(this).attr('pro-handle'), handles) !== -1);
    });
  }

  function isWishlistPage() {
    return window.location.pathname.indexOf('/pages/wishlist') !== -1;
  }

  function getWishlistPageUrl() {
    var root =
      window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

    return root + 'pages/wishlist';
  }

  function getWishlistProductUrl(handle) {
    var root =
      window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

    return root + 'products/' + handle + '?view=for_wishlist';
  }

  function renderWishlistMarkup(markup) {
    var $scroll = $('.pro-wishlist-section .pro-wishlist-wrap .pro-wishlist-scroll');

    if (!$scroll.length) return;

    $scroll.html(markup || EMPTY_STATE_HTML);
    updateWishlistCount();
  }

  function renderWishlistPage() {
    var handles;
    var requests;

    if (!isWishlistPage()) return;

    handles = getWishlistHandles();

    if (!handles.length) {
      renderWishlistMarkup('');
      return;
    }

    requests = $.map(handles, function (handle) {
      return $.ajax({
        url: getWishlistProductUrl(handle),
        type: 'GET'
      }).then(
        function (markup) {
          return markup;
        },
        function () {
          return '';
        }
      );
    });

    $.when.apply($, requests).done(function () {
      var responses = requests.length === 1 ? [arguments[0]] : Array.prototype.slice.call(arguments);
      var markup = $.map(responses, function (response) {
        return typeof response === 'string' ? response : '';
      }).join('');

      renderWishlistMarkup(markup);
    });
  }

  function toggleHandle(handle) {
    var handles = getWishlistHandles();
    var index = $.inArray(handle, handles);

    if (index < 0) {
      handles.push(handle);
    } else {
      handles = $.grep(handles, function (value) {
        return value !== handle;
      });
    }

    saveWishlistHandles(handles);
    return handles;
  }

  $(document).ready(function () {
    syncWishlistUI();
    renderWishlistPage();
  });

  $(document).on('click', '.pro-wishlist.active label', function (event) {
    var $wishlist = $(this).closest('.pro-wishlist');
    var handle = $wishlist.find('input[pro-handle]').attr('pro-handle');

    if (!$wishlist.length || !handle || isWishlistPage()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = getWishlistPageUrl();
  });

  $(document).on('change', '.pro-wishlist input', function () {
    var handle = $(this).attr('pro-handle');

    if (!handle) return;

    toggleHandle(handle);
    syncWishlistUI();

    if (isWishlistPage()) {
      renderWishlistPage();
    }
  });

  $(document).on('click', '.wishlist-prod-remove', function () {
    var $wrap = $(this).closest('.wishlist-wrap');
    var removeItem = $wrap.attr('data-handle');
    var handles = getWishlistHandles();

    handles = $.grep(handles, function (value) {
      return value !== removeItem;
    });

    saveWishlistHandles(handles);
    $wrap.remove();
    syncWishlistUI();

    if (!handles.length) {
      renderWishlistMarkup('');
    }
  });

  $(document).on('click', '.pro-wishlist-section .clear-all-wishlist', function (event) {
    event.preventDefault();

    saveWishlistHandles([]);
    renderWishlistMarkup('');
    syncWishlistUI();
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== WISHLIST_STORAGE_KEY) return;

    syncWishlistUI();
    renderWishlistPage();
  });

  document.addEventListener('shopify:section:load', function () {
    syncWishlistUI();
  });
})(jQuery);
